
import Vue from 'vue'

const locales = {keys(){return []}}
global['____650A0F7____'] = true;
delete global['____650A0F7____'];
global.__uniConfig = {"tabBar":{"color":"#282828","selectedColor":"#ff3366","borderStyle":"white","backgroundColor":"#ffffff","list":[{"pagePath":"pages/index/index","iconPath":"static/images/1-001.png","selectedIconPath":"static/images/1-002.png","text":"首页","redDot":false,"badge":""},{"pagePath":"pages/order_addcart/order_addcart","iconPath":"static/images/3-001.png","selectedIconPath":"static/images/3-002.png","text":"购物车","redDot":false,"badge":""},{"pagePath":"pages/dynamic/index","iconPath":"static/images/2-001.png","selectedIconPath":"static/images/2-002.png","text":"动态","redDot":false,"badge":""},{"pagePath":"pages/service/index","iconPath":"static/images/3-001.png","selectedIconPath":"static/images/3-002.png","text":"服务","redDot":false,"badge":""},{"pagePath":"pages/user/index","iconPath":"static/images/4-001.png","selectedIconPath":"static/images/4-002.png","text":"我的","redDot":false,"badge":""}]},"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"加载中","navigationBarBackgroundColor":"#fff","backgroundColor":"#F8F8F8","titleNView":false},"condition":{"current":0,"list":[{"name":"","path":"","query":""}]},"embeddedAppIdList":["wxef277996acc166c3"]};
global.__uniConfig.compilerVersion = '4.87';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__650A0F7';
global.__uniConfig.appName = '北杰星';
global.__uniConfig.appVersion = '5.5.0';
global.__uniConfig.appVersionCode = '550';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":200000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"SMJBZ-WCHK4-ZPZUA-DSIXI-XDDVQ-XWFX7"}}};
global.__uniConfig.qqMapKey = "SMJBZ-WCHK4-ZPZUA-DSIXI-XDDVQ-XWFX7";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-guide-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/guide/index"+'.vue')), 'pages-guide-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order_addcart-order_addcart', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/order_addcart/order_addcart"+'.vue')), 'pages-order_addcart-order_addcart'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/user/index"+'.vue')), 'pages-user-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-dynamic-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/dynamic/index"+'.vue')), 'pages-dynamic-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-service-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/service/index"+'.vue')), 'pages-service-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-extension-customer_list-chat', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/extension/customer_list/chat"+'.vue')), 'pages-extension-customer_list-chat'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-extension-news_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/extension/news_list/index"+'.vue')), 'pages-extension-news_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-extension-news_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/extension/news_details/index"+'.vue')), 'pages-extension-news_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-extension-news_details-newspc', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/extension/news_details/newspc"+'.vue')), 'pages-extension-news_details-newspc'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_cate-goods_cate', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods_cate/goods_cate"+'.vue')), 'pages-goods_cate-goods_cate'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-dynamicPc-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/dynamicPc/index"+'.vue')), 'pages-dynamicPc-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin_article-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin_article/index"+'.vue')), 'pages-admin_article-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin_article-edit', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin_article/edit"+'.vue')), 'pages-admin_article-edit'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-sample-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/sample/index"+'.vue')), 'pages-sample-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-sample-details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/sample/details"+'.vue')), 'pages-sample-details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-work_order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/work_order/index"+'.vue')), 'pages-work_order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-work_order-details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/work_order/details"+'.vue')), 'pages-work_order-details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-work_order-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/work_order/list"+'.vue')), 'pages-work_order-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pc_sample-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/pc_sample/index"+'.vue')), 'pages-pc_sample-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pc_sample-details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/pc_sample/details"+'.vue')), 'pages-pc_sample-details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pc_sample-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/pc_sample/list"+'.vue')), 'pages-pc_sample-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pc_sample-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/pc_sample/address"+'.vue')), 'pages-pc_sample-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin_sample-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin_sample/index"+'.vue')), 'pages-admin_sample-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin_sample-details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin_sample/details"+'.vue')), 'pages-admin_sample-details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin_sample-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin_sample/list"+'.vue')), 'pages-admin_sample-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin_sample-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin_sample/address"+'.vue')), 'pages-admin_sample-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-app-download-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/app-download/index"+'.vue')), 'pages-app-download-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_list/index"+'.vue')), 'pages-goods-goods_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_search-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_search/index"+'.vue')), 'pages-goods-goods_search-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_pay_status-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_pay_status/index"+'.vue')), 'pages-goods-order_pay_status-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-admin_order_detail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/admin_order_detail/index"+'.vue')), 'pages-goods-admin_order_detail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_comment_con-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_comment_con/index"+'.vue')), 'pages-goods-goods_comment_con-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_comment_con-pc', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_comment_con/pc"+'.vue')), 'pages-goods-goods_comment_con-pc'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_comment_con-lottery_comment', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_comment_con/lottery_comment"+'.vue')), 'pages-goods-goods_comment_con-lottery_comment'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_comment_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_comment_list/index"+'.vue')), 'pages-goods-goods_comment_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_details_store-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_details_store/index"+'.vue')), 'pages-goods-goods_details_store-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_logistics-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_logistics/index"+'.vue')), 'pages-goods-goods_logistics-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_return-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_return/index"+'.vue')), 'pages-goods-goods_return-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-goods_return_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/goods_return_list/index"+'.vue')), 'pages-goods-goods_return_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-lottery-grids-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/lottery/grids/index"+'.vue')), 'pages-goods-lottery-grids-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-lottery-grids-record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/lottery/grids/record"+'.vue')), 'pages-goods-lottery-grids-record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_confirm-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_confirm/index"+'.vue')), 'pages-goods-order_confirm-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_confirm-index_com', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_confirm/index_com"+'.vue')), 'pages-goods-order_confirm-index_com'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_confirm-index_com_pc', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_confirm/index_com_pc"+'.vue')), 'pages-goods-order_confirm-index_com_pc'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_confirm-index_pc', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_confirm/index_pc"+'.vue')), 'pages-goods-order_confirm-index_pc'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_details-pc', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_details/pc"+'.vue')), 'pages-goods-order_details-pc'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_details/index"+'.vue')), 'pages-goods-order_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_list/index"+'.vue')), 'pages-goods-order_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-order_refund_goods-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/order_refund_goods/index"+'.vue')), 'pages-goods-order_refund_goods-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-cashier-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/cashier/index"+'.vue')), 'pages-goods-cashier-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-cashier-pc', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/cashier/pc"+'.vue')), 'pages-goods-cashier-pc'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-cashier-apppay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/cashier/apppay"+'.vue')), 'pages-goods-cashier-apppay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods-cashier-app_paypal', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods/cashier/app_paypal"+'.vue')), 'pages-goods-cashier-app_paypal'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_vip_areer-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_vip_areer/index"+'.vue')), 'pages-users-user_vip_areer-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-privacy-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/privacy/index"+'.vue')), 'pages-users-privacy-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_cancellation-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_cancellation/index"+'.vue')), 'pages-users-user_cancellation-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-message_center-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/message_center/index"+'.vue')), 'pages-users-message_center-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-message_center-messageDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/message_center/messageDetail"+'.vue')), 'pages-users-message_center-messageDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_invoice_order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_invoice_order/index"+'.vue')), 'pages-users-user_invoice_order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-scan_login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/scan_login/index"+'.vue')), 'pages-users-scan_login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-scan_user-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/scan_user/index"+'.vue')), 'pages-users-scan_user-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_invoice_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_invoice_list/index"+'.vue')), 'pages-users-user_invoice_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_invoice_form-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_invoice_form/index"+'.vue')), 'pages-users-user_invoice_form-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-alipay_invoke-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/alipay_invoke/index"+'.vue')), 'pages-users-alipay_invoke-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-wechat_login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/wechat_login/index"+'.vue')), 'pages-users-wechat_login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-binding_phone-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/binding_phone/index"+'.vue')), 'pages-users-binding_phone-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-retrievePassword-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/retrievePassword/index"+'.vue')), 'pages-users-retrievePassword-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_info-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_info/index"+'.vue')), 'pages-users-user_info-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_get_coupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_get_coupon/index"+'.vue')), 'pages-users-user_get_coupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-visit_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/visit_list/index"+'.vue')), 'pages-users-visit_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_goods_collection-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_goods_collection/index"+'.vue')), 'pages-users-user_goods_collection-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_sgin-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_sgin/index"+'.vue')), 'pages-users-user_sgin-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_sgin_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_sgin_list/index"+'.vue')), 'pages-users-user_sgin_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_money-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_money/index"+'.vue')), 'pages-users-user_money-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_bill-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_bill/index"+'.vue')), 'pages-users-user_bill-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_integral-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_integral/index"+'.vue')), 'pages-users-user_integral-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_coupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_coupon/index"+'.vue')), 'pages-users-user_coupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_spread_user-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_spread_user/index"+'.vue')), 'pages-users-user_spread_user-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_spread_code-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_spread_code/index"+'.vue')), 'pages-users-user_spread_code-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_spread_money-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_spread_money/index"+'.vue')), 'pages-users-user_spread_money-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_cash-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_cash/index"+'.vue')), 'pages-users-user_cash-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_vip-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_vip/index"+'.vue')), 'pages-users-user_vip-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_distribution_level-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_distribution_level/index"+'.vue')), 'pages-users-user_distribution_level-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_address_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_address_list/index"+'.vue')), 'pages-users-user_address_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_address-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_address/index"+'.vue')), 'pages-users-user_address-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_phone-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_phone/index"+'.vue')), 'pages-users-user_phone-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_payment-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_payment/index"+'.vue')), 'pages-users-user_payment-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_pwd_edit-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_pwd_edit/index"+'.vue')), 'pages-users-user_pwd_edit-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-promoter-list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/promoter-list/index"+'.vue')), 'pages-users-promoter-list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-promoter-order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/promoter-order/index"+'.vue')), 'pages-users-promoter-order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-promoter_rank-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/promoter_rank/index"+'.vue')), 'pages-users-promoter_rank-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-commission_rank-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/commission_rank/index"+'.vue')), 'pages-users-commission_rank-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-user_return_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/user_return_list/index"+'.vue')), 'pages-users-user_return_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/login/index"+'.vue')), 'pages-users-login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-Auto_login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/Auto_login/index"+'.vue')), 'pages-users-Auto_login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-payment_on_behalf-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/payment_on_behalf/index"+'.vue')), 'pages-users-payment_on_behalf-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-payment_on_behalf-pay_status', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/payment_on_behalf/pay_status"+'.vue')), 'pages-users-payment_on_behalf-pay_status'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-staff_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/staff_list/index"+'.vue')), 'pages-users-staff_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-users-auth-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/users/auth/index"+'.vue')), 'pages-users-auth-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods_details/index"+'.vue')), 'pages-goods_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-goods_details-commentList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/goods_details/commentList"+'.vue')), 'pages-goods_details-commentList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_bargain-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/goods_bargain/index"+'.vue')), 'pages-activity-goods_bargain-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_bargain_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/goods_bargain_details/index"+'.vue')), 'pages-activity-goods_bargain_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_combination-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/goods_combination/index"+'.vue')), 'pages-activity-goods_combination-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_combination_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/goods_combination_details/index"+'.vue')), 'pages-activity-goods_combination_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_combination_status-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/goods_combination_status/index"+'.vue')), 'pages-activity-goods_combination_status-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_seckill-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/goods_seckill/index"+'.vue')), 'pages-activity-goods_seckill-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-goods_seckill_details-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/goods_seckill_details/index"+'.vue')), 'pages-activity-goods_seckill_details-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-poster-poster-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/poster-poster/index"+'.vue')), 'pages-activity-poster-poster-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-bargain-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/bargain/index"+'.vue')), 'pages-activity-bargain-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activity-presell-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/activity/presell/index"+'.vue')), 'pages-activity-presell-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-custom_date-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/custom_date/index"+'.vue')), 'pages-admin-custom_date-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-order-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/order/index"+'.vue')), 'pages-admin-order-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-bind_product', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/bind_product"+'.vue')), 'pages-admin-bind_product'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-admin_bind_product', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/admin_bind_product"+'.vue')), 'pages-admin-admin_bind_product'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-orderList-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/orderList/index"+'.vue')), 'pages-admin-orderList-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-orderDetail-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/orderDetail/index"+'.vue')), 'pages-admin-orderDetail-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-delivery-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/delivery/index"+'.vue')), 'pages-admin-delivery-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-statistics-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/statistics/index"+'.vue')), 'pages-admin-statistics-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-admin-order_cancellation-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/admin/order_cancellation/index"+'.vue')), 'pages-admin-order_cancellation-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-columnGoods-HotNewGoods-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/columnGoods/HotNewGoods/index"+'.vue')), 'pages-columnGoods-HotNewGoods-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-columnGoods-HotNewGoods-feedback', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/columnGoods/HotNewGoods/feedback"+'.vue')), 'pages-columnGoods-HotNewGoods-feedback'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-columnGoods-live_list-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/columnGoods/live_list/index"+'.vue')), 'pages-columnGoods-live_list-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-web_view-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/web_view/index"+'.vue')), 'pages-annex-web_view-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-vip_paid-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/vip_paid/index"+'.vue')), 'pages-annex-vip_paid-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-vip_coupon-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/vip_coupon/index"+'.vue')), 'pages-annex-vip_coupon-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-vip_clause-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/vip_clause/index"+'.vue')), 'pages-annex-vip_clause-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-vip_active-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/vip_active/index"+'.vue')), 'pages-annex-vip_active-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-offline_pay-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/offline_pay/index"+'.vue')), 'pages-annex-offline_pay-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-offline_result-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/offline_result/index"+'.vue')), 'pages-annex-offline_result-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-special-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/special/index"+'.vue')), 'pages-annex-special-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-annex-settled-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/annex/settled/index"+'.vue')), 'pages-annex-settled-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/index"+'.vue')), 'pages-points_mall-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_goods_list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/integral_goods_list"+'.vue')), 'pages-points_mall-integral_goods_list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_goods_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/integral_goods_details"+'.vue')), 'pages-points_mall-integral_goods_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-exchange_record', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/exchange_record"+'.vue')), 'pages-points_mall-exchange_record'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/integral_order"+'.vue')), 'pages-points_mall-integral_order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-user_address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/user_address"+'.vue')), 'pages-points_mall-user_address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_order_status', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/integral_order_status"+'.vue')), 'pages-points_mall-integral_order_status'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-integral_order_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/integral_order_details"+'.vue')), 'pages-points_mall-integral_order_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-points_mall-logistics_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("E:/WXAPP/北极星uni-app/pages/points_mall/logistics_details"+'.vue')), 'pages-points_mall-logistics_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/guide/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"titleNView":false})
      },
      [
        createElement('pages-guide-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-guide-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/guide/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"首页","navigationStyle":"custom","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
isQuit:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/pages/order_addcart/order_addcart',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"购物车"})
      },
      [
        createElement('pages-order_addcart-order_addcart', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-order_addcart-order_addcart',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order_addcart/order_addcart',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:0
}
},
{
path: '/pages/user/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:4
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人中心","enablePullDownRefresh":true})
      },
      [
        createElement('pages-user-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-user-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user/index',
isQuit:true,
isTabBar:true,
tabBarIndex:4,
  windowTop:0
}
},
{
path: '/pages/dynamic/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarTextStyle":"black","navigationBarTitleText":"动态"})
      },
      [
        createElement('pages-dynamic-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:5,
  name:'pages-dynamic-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/dynamic/index',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:0
}
},
{
path: '/pages/service/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTextStyle":"black","navigationBarTitleText":"技术服务"})
      },
      [
        createElement('pages-service-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:6,
  name:'pages-service-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/service/index',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:0
}
},
{
path: '/pages/extension/customer_list/chat',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"对话详情","navigationBarBackgroundColor":"#fff","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-extension-customer_list-chat', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-extension-customer_list-chat',
  isNVue:false,maxWidth:0,
  pagePath:'pages/extension/customer_list/chat',
  windowTop:0
}
},
{
path: '/pages/extension/news_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资讯"})
      },
      [
        createElement('pages-extension-news_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-extension-news_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/extension/news_list/index',
  windowTop:0
}
},
{
path: '/pages/extension/news_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"black","navigationBarTitleText":"详情"})
      },
      [
        createElement('pages-extension-news_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-extension-news_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/extension/news_details/index',
  windowTop:0
}
},
{
path: '/pages/extension/news_details/newspc',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTextStyle":"black","navigationBarTitleText":"文章详情"})
      },
      [
        createElement('pages-extension-news_details-newspc', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-extension-news_details-newspc',
  isNVue:false,maxWidth:0,
  pagePath:'pages/extension/news_details/newspc',
  windowTop:0
}
},
{
path: '/pages/goods_cate/goods_cate',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品分类","navigationStyle":"custom"})
      },
      [
        createElement('pages-goods_cate-goods_cate', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods_cate-goods_cate',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_cate/goods_cate',
  windowTop:0
}
},
{
path: '/pages/dynamicPc/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"动态"})
      },
      [
        createElement('pages-dynamicPc-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-dynamicPc-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/dynamicPc/index',
  windowTop:0
}
},
{
path: '/pages/admin_article/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"文章管理"})
      },
      [
        createElement('pages-admin_article-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin_article-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin_article/index',
  windowTop:0
}
},
{
path: '/pages/admin_article/edit',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"发布新文章"})
      },
      [
        createElement('pages-admin_article-edit', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin_article-edit',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin_article/edit',
  windowTop:0
}
},
{
path: '/pages/sample/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新建寄样"})
      },
      [
        createElement('pages-sample-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-sample-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/sample/index',
  windowTop:0
}
},
{
path: '/pages/sample/details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"测试详情"})
      },
      [
        createElement('pages-sample-details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-sample-details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/sample/details',
  windowTop:0
}
},
{
path: '/pages/work_order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提交工单","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-work_order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-work_order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/work_order/index',
  windowTop:0
}
},
{
path: '/pages/work_order/details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工单详情"})
      },
      [
        createElement('pages-work_order-details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-work_order-details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/work_order/details',
  windowTop:0
}
},
{
path: '/pages/work_order/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"工单列表"})
      },
      [
        createElement('pages-work_order-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-work_order-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/work_order/list',
  windowTop:0
}
},
{
path: '/pages/pc_sample/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"寄样测试"})
      },
      [
        createElement('pages-pc_sample-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pc_sample-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pc_sample/index',
  windowTop:0
}
},
{
path: '/pages/pc_sample/details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"测试详情"})
      },
      [
        createElement('pages-pc_sample-details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pc_sample-details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pc_sample/details',
  windowTop:0
}
},
{
path: '/pages/pc_sample/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"测试列表"})
      },
      [
        createElement('pages-pc_sample-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pc_sample-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pc_sample/list',
  windowTop:0
}
},
{
path: '/pages/pc_sample/address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加地址"})
      },
      [
        createElement('pages-pc_sample-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pc_sample-address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pc_sample/address',
  windowTop:0
}
},
{
path: '/pages/admin_sample/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"寄样测试"})
      },
      [
        createElement('pages-admin_sample-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin_sample-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin_sample/index',
  windowTop:0
}
},
{
path: '/pages/admin_sample/details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"测试详情"})
      },
      [
        createElement('pages-admin_sample-details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin_sample-details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin_sample/details',
  windowTop:0
}
},
{
path: '/pages/admin_sample/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"测试列表"})
      },
      [
        createElement('pages-admin_sample-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin_sample-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin_sample/list',
  windowTop:0
}
},
{
path: '/pages/admin_sample/address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加地址"})
      },
      [
        createElement('pages-admin_sample-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin_sample-address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin_sample/address',
  windowTop:0
}
},
{
path: '/pages/app-download/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","transparentTitle":"auto"})
      },
      [
        createElement('pages-app-download-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-app-download-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/app-download/index',
  windowTop:0
}
},
{
path: '/pages/goods/goods_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表"})
      },
      [
        createElement('pages-goods-goods_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_list/index',
  windowTop:0
}
},
{
path: '/pages/goods/goods_search/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索商品"})
      },
      [
        createElement('pages-goods-goods_search-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_search-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_search/index',
  windowTop:0
}
},
{
path: '/pages/goods/order_pay_status/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付成功"})
      },
      [
        createElement('pages-goods-order_pay_status-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_pay_status-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_pay_status/index',
  windowTop:0
}
},
{
path: '/pages/goods/admin_order_detail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-goods-admin_order_detail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-admin_order_detail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/admin_order_detail/index',
  windowTop:0
}
},
{
path: '/pages/goods/goods_comment_con/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品评价"})
      },
      [
        createElement('pages-goods-goods_comment_con-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_comment_con-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_comment_con/index',
  windowTop:0
}
},
{
path: '/pages/goods/goods_comment_con/pc',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品评价"})
      },
      [
        createElement('pages-goods-goods_comment_con-pc', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_comment_con-pc',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_comment_con/pc',
  windowTop:0
}
},
{
path: '/pages/goods/goods_comment_con/lottery_comment',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单评价"})
      },
      [
        createElement('pages-goods-goods_comment_con-lottery_comment', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_comment_con-lottery_comment',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_comment_con/lottery_comment',
  windowTop:0
}
},
{
path: '/pages/goods/goods_comment_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品评分"})
      },
      [
        createElement('pages-goods-goods_comment_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_comment_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_comment_list/index',
  windowTop:0
}
},
{
path: '/pages/goods/goods_details_store/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"门店列表"})
      },
      [
        createElement('pages-goods-goods_details_store-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_details_store-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_details_store/index',
  windowTop:0
}
},
{
path: '/pages/goods/goods_logistics/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"物流信息"})
      },
      [
        createElement('pages-goods-goods_logistics-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_logistics-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_logistics/index',
  windowTop:0
}
},
{
path: '/pages/goods/goods_return/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"申请退货"})
      },
      [
        createElement('pages-goods-goods_return-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_return-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_return/index',
  windowTop:0
}
},
{
path: '/pages/goods/goods_return_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退货列表"})
      },
      [
        createElement('pages-goods-goods_return_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-goods_return_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/goods_return_list/index',
  windowTop:0
}
},
{
path: '/pages/goods/lottery/grids/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"抽奖活动"})
      },
      [
        createElement('pages-goods-lottery-grids-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-lottery-grids-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/lottery/grids/index',
  windowTop:0
}
},
{
path: '/pages/goods/lottery/grids/record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"中奖记录"})
      },
      [
        createElement('pages-goods-lottery-grids-record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-lottery-grids-record',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/lottery/grids/record',
  windowTop:0
}
},
{
path: '/pages/goods/order_confirm/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提交订单"})
      },
      [
        createElement('pages-goods-order_confirm-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_confirm-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_confirm/index',
  windowTop:0
}
},
{
path: '/pages/goods/order_confirm/index_com',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提交订单"})
      },
      [
        createElement('pages-goods-order_confirm-index_com', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_confirm-index_com',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_confirm/index_com',
  windowTop:0
}
},
{
path: '/pages/goods/order_confirm/index_com_pc',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提交订单"})
      },
      [
        createElement('pages-goods-order_confirm-index_com_pc', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_confirm-index_com_pc',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_confirm/index_com_pc',
  windowTop:0
}
},
{
path: '/pages/goods/order_confirm/index_pc',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提交订单"})
      },
      [
        createElement('pages-goods-order_confirm-index_pc', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_confirm-index_pc',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_confirm/index_pc',
  windowTop:0
}
},
{
path: '/pages/goods/order_details/pc',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-goods-order_details-pc', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_details-pc',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_details/pc',
  windowTop:0
}
},
{
path: '/pages/goods/order_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-goods-order_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_details/index',
  windowTop:0
}
},
{
path: '/pages/goods/order_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的订单"})
      },
      [
        createElement('pages-goods-order_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_list/index',
  windowTop:0
}
},
{
path: '/pages/goods/order_refund_goods/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退回商品"})
      },
      [
        createElement('pages-goods-order_refund_goods-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-order_refund_goods-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/order_refund_goods/index',
  windowTop:0
}
},
{
path: '/pages/goods/cashier/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收银台"})
      },
      [
        createElement('pages-goods-cashier-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-cashier-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/cashier/index',
  windowTop:0
}
},
{
path: '/pages/goods/cashier/pc',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收银台"})
      },
      [
        createElement('pages-goods-cashier-pc', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-cashier-pc',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/cashier/pc',
  windowTop:0
}
},
{
path: '/pages/goods/cashier/apppay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收银台"})
      },
      [
        createElement('pages-goods-cashier-apppay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-cashier-apppay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/cashier/apppay',
  windowTop:0
}
},
{
path: '/pages/goods/cashier/app_paypal',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"PayPal"})
      },
      [
        createElement('pages-goods-cashier-app_paypal', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods-cashier-app_paypal',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods/cashier/app_paypal',
  windowTop:0
}
},
{
path: '/pages/users/user_vip_areer/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"经验记录"})
      },
      [
        createElement('pages-users-user_vip_areer-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_vip_areer-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_vip_areer/index',
  windowTop:0
}
},
{
path: '/pages/users/privacy/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"隐私协议"})
      },
      [
        createElement('pages-users-privacy-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-privacy-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/privacy/index',
  windowTop:0
}
},
{
path: '/pages/users/user_cancellation/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注销协议"})
      },
      [
        createElement('pages-users-user_cancellation-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_cancellation-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_cancellation/index',
  windowTop:0
}
},
{
path: '/pages/users/message_center/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消息中心","enablePullDownRefresh":true})
      },
      [
        createElement('pages-users-message_center-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-message_center-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/message_center/index',
  windowTop:0
}
},
{
path: '/pages/users/message_center/messageDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"消息详情"})
      },
      [
        createElement('pages-users-message_center-messageDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-message_center-messageDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/message_center/messageDetail',
  windowTop:0
}
},
{
path: '/pages/users/user_invoice_order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"发票详情"})
      },
      [
        createElement('pages-users-user_invoice_order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_invoice_order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_invoice_order/index',
  windowTop:0
}
},
{
path: '/pages/users/scan_login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"授权登录"})
      },
      [
        createElement('pages-users-scan_login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-scan_login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/scan_login/index',
  windowTop:0
}
},
{
path: '/pages/users/scan_user/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"扫码授权登录"})
      },
      [
        createElement('pages-users-scan_user-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-scan_user-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/scan_user/index',
  windowTop:0
}
},
{
path: '/pages/users/user_invoice_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"发票管理"})
      },
      [
        createElement('pages-users-user_invoice_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_invoice_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_invoice_list/index',
  windowTop:0
}
},
{
path: '/pages/users/user_invoice_form/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加新发票"})
      },
      [
        createElement('pages-users-user_invoice_form-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_invoice_form-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_invoice_form/index',
  windowTop:0
}
},
{
path: '/pages/users/alipay_invoke/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付提示"})
      },
      [
        createElement('pages-users-alipay_invoke-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-alipay_invoke-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/alipay_invoke/index',
  windowTop:0
}
},
{
path: '/pages/users/wechat_login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTextStyle":"white","navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pages-users-wechat_login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-wechat_login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/wechat_login/index',
  windowTop:0
}
},
{
path: '/pages/users/binding_phone/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom"})
      },
      [
        createElement('pages-users-binding_phone-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-binding_phone-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/binding_phone/index',
  windowTop:0
}
},
{
path: '/pages/users/retrievePassword/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"忘记密码"})
      },
      [
        createElement('pages-users-retrievePassword-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-retrievePassword-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/retrievePassword/index',
  windowTop:0
}
},
{
path: '/pages/users/user_info/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"设置"})
      },
      [
        createElement('pages-users-user_info-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_info-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_info/index',
  windowTop:0
}
},
{
path: '/pages/users/user_get_coupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"领取优惠券"})
      },
      [
        createElement('pages-users-user_get_coupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_get_coupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_get_coupon/index',
  windowTop:0
}
},
{
path: '/pages/users/visit_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"浏览记录"})
      },
      [
        createElement('pages-users-visit_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-visit_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/visit_list/index',
  windowTop:0
}
},
{
path: '/pages/users/user_goods_collection/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"收藏商品"})
      },
      [
        createElement('pages-users-user_goods_collection-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_goods_collection-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_goods_collection/index',
  windowTop:0
}
},
{
path: '/pages/users/user_sgin/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"签到"})
      },
      [
        createElement('pages-users-user_sgin-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_sgin-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_sgin/index',
  windowTop:0
}
},
{
path: '/pages/users/user_sgin_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"签到记录"})
      },
      [
        createElement('pages-users-user_sgin_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_sgin_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_sgin_list/index',
  windowTop:0
}
},
{
path: '/pages/users/user_money/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的账户"})
      },
      [
        createElement('pages-users-user_money-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_money-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_money/index',
  windowTop:0
}
},
{
path: '/pages/users/user_bill/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"账单明细"})
      },
      [
        createElement('pages-users-user_bill-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_bill-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_bill/index',
  windowTop:0
}
},
{
path: '/pages/users/user_integral/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分详情"})
      },
      [
        createElement('pages-users-user_integral-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_integral-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_integral/index',
  windowTop:0
}
},
{
path: '/pages/users/user_coupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的优惠券"})
      },
      [
        createElement('pages-users-user_coupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_coupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_coupon/index',
  windowTop:0
}
},
{
path: '/pages/users/user_spread_user/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的推广"})
      },
      [
        createElement('pages-users-user_spread_user-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_spread_user-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_spread_user/index',
  windowTop:0
}
},
{
path: '/pages/users/user_spread_code/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分销海报"})
      },
      [
        createElement('pages-users-user_spread_code-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_spread_code-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_spread_code/index',
  windowTop:0
}
},
{
path: '/pages/users/user_spread_money/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金记录"})
      },
      [
        createElement('pages-users-user_spread_money-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_spread_money-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_spread_money/index',
  windowTop:0
}
},
{
path: '/pages/users/user_cash/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"提现","navigationBarBackgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-user_cash-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_cash-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_cash/index',
  windowTop:0
}
},
{
path: '/pages/users/user_vip/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的等级","navigationBarBackgroundColor":"#232323"})
      },
      [
        createElement('pages-users-user_vip-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_vip-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_vip/index',
  windowTop:0
}
},
{
path: '/pages/users/user_distribution_level/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分销等级","navigationBarBackgroundColor":"#232323"})
      },
      [
        createElement('pages-users-user_distribution_level-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_distribution_level-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_distribution_level/index',
  windowTop:0
}
},
{
path: '/pages/users/user_address_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"地址管理"})
      },
      [
        createElement('pages-users-user_address_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_address_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_address_list/index',
  windowTop:0
}
},
{
path: '/pages/users/user_address/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"添加地址"})
      },
      [
        createElement('pages-users-user_address-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_address-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_address/index',
  windowTop:0
}
},
{
path: '/pages/users/user_phone/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定手机"})
      },
      [
        createElement('pages-users-user_phone-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_phone-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_phone/index',
  windowTop:0
}
},
{
path: '/pages/users/user_payment/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"余额充值"})
      },
      [
        createElement('pages-users-user_payment-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_payment-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_payment/index',
  windowTop:0
}
},
{
path: '/pages/users/user_pwd_edit/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"修改密码"})
      },
      [
        createElement('pages-users-user_pwd_edit-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_pwd_edit-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_pwd_edit/index',
  windowTop:0
}
},
{
path: '/pages/users/promoter-list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"推广人列表"})
      },
      [
        createElement('pages-users-promoter-list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-promoter-list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/promoter-list/index',
  windowTop:0
}
},
{
path: '/pages/users/promoter-order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"推广人订单"})
      },
      [
        createElement('pages-users-promoter-order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-promoter-order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/promoter-order/index',
  windowTop:0
}
},
{
path: '/pages/users/promoter_rank/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"推广人排行"})
      },
      [
        createElement('pages-users-promoter_rank-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-promoter_rank-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/promoter_rank/index',
  windowTop:0
}
},
{
path: '/pages/users/commission_rank/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"佣金排行","navigationBarBackgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-users-commission_rank-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-commission_rank-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/commission_rank/index',
  windowTop:0
}
},
{
path: '/pages/users/user_return_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"退货列表"})
      },
      [
        createElement('pages-users-user_return_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-user_return_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/user_return_list/index',
  windowTop:0
}
},
{
path: '/pages/users/login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-users-login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/login/index',
  windowTop:0
}
},
{
path: '/pages/users/Auto_login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"加载中..."})
      },
      [
        createElement('pages-users-Auto_login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-Auto_login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/Auto_login/index',
  windowTop:0
}
},
{
path: '/pages/users/payment_on_behalf/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"好友代付"})
      },
      [
        createElement('pages-users-payment_on_behalf-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-payment_on_behalf-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/payment_on_behalf/index',
  windowTop:0
}
},
{
path: '/pages/users/payment_on_behalf/pay_status',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"代付成功"})
      },
      [
        createElement('pages-users-payment_on_behalf-pay_status', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-payment_on_behalf-pay_status',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/payment_on_behalf/pay_status',
  windowTop:0
}
},
{
path: '/pages/users/staff_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"员工列表","navigationBarBackgroundColor":"#e93323"})
      },
      [
        createElement('pages-users-staff_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-staff_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/staff_list/index',
  windowTop:0
}
},
{
path: '/pages/users/auth/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-users-auth-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-users-auth-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/users/auth/index',
  windowTop:0
}
},
{
path: '/pages/goods_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","transparentTitle":"auto"})
      },
      [
        createElement('pages-goods_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_details/index',
  windowTop:0
}
},
{
path: '/pages/goods_details/commentList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"问大家","transparentTitle":"auto"})
      },
      [
        createElement('pages-goods_details-commentList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-goods_details-commentList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/goods_details/commentList',
  windowTop:0
}
},
{
path: '/pages/activity/goods_bargain/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activity-goods_bargain-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_bargain-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_bargain/index',
  windowTop:0
}
},
{
path: '/pages/activity/goods_bargain_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activity-goods_bargain_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_bargain_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_bargain_details/index',
  windowTop:0
}
},
{
path: '/pages/activity/goods_combination/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-activity-goods_combination-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_combination-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_combination/index',
  windowTop:0
}
},
{
path: '/pages/activity/goods_combination_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-activity-goods_combination_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_combination_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_combination_details/index',
  windowTop:0
}
},
{
path: '/pages/activity/goods_combination_status/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"拼团"})
      },
      [
        createElement('pages-activity-goods_combination_status-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_combination_status-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_combination_status/index',
  windowTop:0
}
},
{
path: '/pages/activity/goods_seckill/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"限时秒杀"})
      },
      [
        createElement('pages-activity-goods_seckill-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_seckill-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_seckill/index',
  windowTop:0
}
},
{
path: '/pages/activity/goods_seckill_details/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-activity-goods_seckill_details-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-goods_seckill_details-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/goods_seckill_details/index',
  windowTop:0
}
},
{
path: '/pages/activity/poster-poster/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"砍价海报"})
      },
      [
        createElement('pages-activity-poster-poster-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-poster-poster-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/poster-poster/index',
  windowTop:0
}
},
{
path: '/pages/activity/bargain/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"砍价记录"})
      },
      [
        createElement('pages-activity-bargain-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-bargain-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/bargain/index',
  windowTop:0
}
},
{
path: '/pages/activity/presell/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预售列表"})
      },
      [
        createElement('pages-activity-presell-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activity-presell-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activity/presell/index',
  windowTop:0
}
},
{
path: '/pages/admin/custom_date/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择日期"})
      },
      [
        createElement('pages-admin-custom_date-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-custom_date-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/custom_date/index',
  windowTop:0
}
},
{
path: '/pages/admin/order/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单统计"})
      },
      [
        createElement('pages-admin-order-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-order-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/order/index',
  windowTop:0
}
},
{
path: '/pages/admin/bind_product',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定产品管理"})
      },
      [
        createElement('pages-admin-bind_product', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-bind_product',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/bind_product',
  windowTop:0
}
},
{
path: '/pages/admin/admin_bind_product',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定产品管理"})
      },
      [
        createElement('pages-admin-admin_bind_product', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-admin_bind_product',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/admin_bind_product',
  windowTop:0
}
},
{
path: '/pages/admin/orderList/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单列表"})
      },
      [
        createElement('pages-admin-orderList-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-orderList-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/orderList/index',
  windowTop:0
}
},
{
path: '/pages/admin/orderDetail/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情"})
      },
      [
        createElement('pages-admin-orderDetail-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-orderDetail-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/orderDetail/index',
  windowTop:0
}
},
{
path: '/pages/admin/delivery/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单发货"})
      },
      [
        createElement('pages-admin-delivery-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-delivery-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/delivery/index',
  windowTop:0
}
},
{
path: '/pages/admin/statistics/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单数据统计"})
      },
      [
        createElement('pages-admin-statistics-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-statistics-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/statistics/index',
  windowTop:0
}
},
{
path: '/pages/admin/order_cancellation/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单核销"})
      },
      [
        createElement('pages-admin-order_cancellation-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-admin-order_cancellation-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/admin/order_cancellation/index',
  windowTop:0
}
},
{
path: '/pages/columnGoods/HotNewGoods/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"精品推荐"})
      },
      [
        createElement('pages-columnGoods-HotNewGoods-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-columnGoods-HotNewGoods-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/columnGoods/HotNewGoods/index',
  windowTop:0
}
},
{
path: '/pages/columnGoods/HotNewGoods/feedback',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的客服","navigationBarTextStyle":"white","navigationBarBackgroundColor":"#3A3A3A"})
      },
      [
        createElement('pages-columnGoods-HotNewGoods-feedback', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-columnGoods-HotNewGoods-feedback',
  isNVue:false,maxWidth:0,
  pagePath:'pages/columnGoods/HotNewGoods/feedback',
  windowTop:0
}
},
{
path: '/pages/columnGoods/live_list/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"精彩内容"})
      },
      [
        createElement('pages-columnGoods-live_list-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-columnGoods-live_list-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/columnGoods/live_list/index',
  windowTop:0
}
},
{
path: '/pages/annex/web_view/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-annex-web_view-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-web_view-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/web_view/index',
  windowTop:0
}
},
{
path: '/pages/annex/vip_paid/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"SVIP会员"})
      },
      [
        createElement('pages-annex-vip_paid-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-vip_paid-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/vip_paid/index',
  windowTop:0
}
},
{
path: '/pages/annex/vip_coupon/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员优惠券"})
      },
      [
        createElement('pages-annex-vip_coupon-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-vip_coupon-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/vip_coupon/index',
  windowTop:0
}
},
{
path: '/pages/annex/vip_clause/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员协议"})
      },
      [
        createElement('pages-annex-vip_clause-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-vip_clause-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/vip_clause/index',
  windowTop:0
}
},
{
path: '/pages/annex/vip_active/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"激活会员"})
      },
      [
        createElement('pages-annex-vip_active-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-vip_active-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/vip_active/index',
  windowTop:0
}
},
{
path: '/pages/annex/offline_pay/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付"})
      },
      [
        createElement('pages-annex-offline_pay-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-offline_pay-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/offline_pay/index',
  windowTop:0
}
},
{
path: '/pages/annex/offline_result/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"支付结果"})
      },
      [
        createElement('pages-annex-offline_result-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-offline_result-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/offline_result/index',
  windowTop:0
}
},
{
path: '/pages/annex/special/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","navigationBarTextStyle":"white"})
      },
      [
        createElement('pages-annex-special-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-special-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/special/index',
  windowTop:0
}
},
{
path: '/pages/annex/settled/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"分销申请"})
      },
      [
        createElement('pages-annex-settled-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-annex-settled-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/annex/settled/index',
  windowTop:0
}
},
{
path: '/pages/points_mall/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTextStyle":"white","navigationBarBackgroundColor":"#333333","navigationBarTitleText":"积分商城"})
      },
      [
        createElement('pages-points_mall-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/index',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_goods_list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"商品列表"})
      },
      [
        createElement('pages-points_mall-integral_goods_list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_goods_list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_goods_list',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_goods_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-points_mall-integral_goods_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_goods_details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_goods_details',
  windowTop:0
}
},
{
path: '/pages/points_mall/exchange_record',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换记录"})
      },
      [
        createElement('pages-points_mall-exchange_record', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-exchange_record',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/exchange_record',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分订单"})
      },
      [
        createElement('pages-points_mall-integral_order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_order',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_order',
  windowTop:0
}
},
{
path: '/pages/points_mall/user_address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"选择地址"})
      },
      [
        createElement('pages-points_mall-user_address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-user_address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/user_address',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_order_status',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换成功"})
      },
      [
        createElement('pages-points_mall-integral_order_status', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_order_status',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_order_status',
  windowTop:0
}
},
{
path: '/pages/points_mall/integral_order_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换订单详情"})
      },
      [
        createElement('pages-points_mall-integral_order_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-integral_order_details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/integral_order_details',
  windowTop:0
}
},
{
path: '/pages/points_mall/logistics_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换物流详情"})
      },
      [
        createElement('pages-points_mall-logistics_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-points_mall-logistics_details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/points_mall/logistics_details',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
